import { createAction } from 'redux-actions';

export const setHeadingAssignmentRefresh = createAction(
  'SET_HEADING_ASSIGNMENT_REFRESH',
);
